<app-iframe *ngIf="src" [width]="width" [height]="height" [src]="src"></app-iframe>
<div style="color:#666;font-size:10px; text-align:right; width:215px;">
  powered by Surfing Waves
</div>
